export enum AssetsWorkspaceCapabilityAccessOperation {
    create = "509397c2-40ae-4d02-89c9-bd51063a06a9",
    read = "6deafe9c-255b-4aac-b890-7d3cb0a7ebab",
    update = "da8b3b66-46f8-49ee-b0b5-c37099457be9",
    delete = "9f958ad8-86ab-459e-bbed-7d700ab583ab",
}
